<template>
  <div class="page-header align-items-start min-vh-100">
    <span class="mask opacity-6"></span>
    <div class="container my-auto auth-container">
      <div class="row">
        <div class="auth-card card-body text-center">
          <div v-if="loading" class="spinner"></div>

          <div v-else-if="error" class="return-card">
            <img src="@/assets/img/logo.png" class="logo" />
            <span
              >Não foi possível validar. O link pode estar inválido, já usado
              ou expirado (válido por 48 horas). Peça um novo em Reenviar
              confirmação no login.</span
            >
            <button @click="verifyAuthByCode" class="retry-btn">
              Tentar novamente
            </button>
          </div>

          <div v-else class="return-card">
            <img src="@/assets/img/logo.png" class="logo" />
            <span>Sucesso! Sua conta foi verificada.</span>
            <button @click="goToAdmin" class="retry-btn">
              Entrar no meu painel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import LoggingMixin from "@/mixins/LoggingMixin.js";

import AuthHttp from "@/http/AuthHttp.js";

export default {
  name: "validate",
  mixins: [LoggingMixin],
  data() {
    return {
      loading: true,
      error: false,
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  async mounted() {
    await this.verifyAuthByCode();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async verifyAuthByCode() {
      this.loading = true;
      this.error = false;

      const code = this.$route.params.code;
      if (!code) {
        this.loading = false;
        this.error = true;
        this.$log.logError("Código de validação não encontrado", "ValidateUser");
        return;
      }
      try {
        await AuthHttp.verifyUserByCode(code);
        this.$log.log("AUTH", "VALIDAÇÃO", `Conta validada com sucesso - Código: ${code}`);
      } catch (error) {
        console.error("Erro ao validar código:", error);
        this.$log.logError(
          `Erro ao validar código: ${error.message || 'Erro desconhecido'}`,
          "ValidateUser"
        );
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    goToAdmin() {
      this.$log.log("AUTH", "AÇÃO", "Redirecionamento para painel após validação");
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.auth-container {
  background: linear-gradient(135deg, #e8d2ff 0%, #ffb7db 100%);
  height: 80vh;
  width: 80vw;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.auth-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 150px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.return-card {
  max-width: 300px;
}

.logo {
  width: 50%;
  display: block;
  margin: 0 auto 10px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #d9b3ff;
  border-left-color: #ef0079;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.retry-btn {
  margin-top: 20px;
  padding-inline: 16px;
  background: #ef0079;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  height: 35px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
